import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

/** Primary / secondary CTAs for a step (back control lives in the layout gutter). */
const OnboardingStepActions = ({ children }: Props) => (
  <div className="mt-5">
    <div className="flex flex-wrap items-center gap-2 [&>a]:no-underline [&>a>button]:min-w-[min(100%,200px)] [&>a>button]:flex-[1_1_200px] [&>button]:min-w-[min(100%,200px)] [&>button]:flex-[1_1_200px]">
      {children}
    </div>
  </div>
);

export default OnboardingStepActions;
